<div class="sample-dialog">
  @if (for === 'VehicleGrant') {
    <div>
      <img src="/assets/image/vehicle_grant_sample.png" alt="" width="100%" />
    </div>
  }
  @if (for === 'VehiclePhoto') {
    <div>
      <img src="/assets/image/vehicle_photo_sample.png" alt="" width="100%" />
    </div>
  }
</div>
